import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { DictDataForm, DictDataQuery, DictDataVO,DictDataListType } from './types';
// 根据字典类型查询字典数据信息
export function getDicts(dictType: string): AxiosPromise<DictDataListType[]> {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  });
}

// 查询字典数据列表
export function listData(query: DictDataQuery): AxiosPromise<DictDataVO[]> {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params: query
  });
}

// 查询字典数据详细
export function getData(dictCode: string | number): AxiosPromise<DictDataVO> {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'get'
  });
}

// 新增字典数据
export function addData(data: DictDataForm) {
  return request({
    url: '/system/dict/data',
    method: 'post',
    data: data
  });
}

// 修改字典数据
export function updateData(data: DictDataForm) {
  return request({
    url: '/system/dict/data',
    method: 'put',
    data: data
  });
}

// 删除字典数据
export function delData(dictCode: string | number | Array<string | number>) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'delete'
  });
}
//获取消息翻译列表分页
export function getMessageLocaleList(param){
  return request({
    url: '/system/message/locale/list',
    method: 'get',
    params: param
  });
}
/**新增消息翻译 */
export function addMessageLocale(data){
  return request({
    url: '/system/message/locale',
    method: 'post',
    data: data
  });
}
/**修改消息翻译 */
export function updateMessageLocale(data){ 
  return request({
    url: '/system/message/locale',
    method: 'put',
    data: data
  });
}
/**删除消息翻译 */
export function delMessageLocale(messageIds){ 
  return request({
    url: '/system/message/locale/all/' + messageIds,
    method: 'delete'
  });
}